import {
	SET_EVENT_CATEGORIES,
	SET_EVENT_CATEGORY,
	CLEAR_EVENT_CATEGORIES,
	CLEAR_EVENT_CATEGORY,
	ADD_EVENT_CATEGORY,
	UPDATE_EVENT_CATEGORY,
	REMOVE_EVENT_CATEGORY,
} from './actionTypes';

export const eventCategory = (state = {}, action) => {
	switch (action.type) {
		case SET_EVENT_CATEGORY:
			return action.payload;
		case UPDATE_EVENT_CATEGORY:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_EVENT_CATEGORY:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_EVENT_CATEGORIES:
			return action.payload;
		case ADD_EVENT_CATEGORY:
			return [...state, action.payload];
		case UPDATE_EVENT_CATEGORY:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_EVENT_CATEGORY:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_EVENT_CATEGORIES:
			return [];
		default:
			return state;
	}
};
